import {CONST} from '../../config'
/*************************************************************
 * RowActMixin
 *     행의 동작과 관련된 행위를 처리하는 Mixin 입니다.
 *      ex) 행선택, 행 수정/삭제 등
 *************************************************************/
export default {
    data() {return {
        //-----------------------------------------------
        // Selection
        mx_selected     : [],
        mx_focused      : null,
        vars_lastSelKey : null,
        //-----------------------------------------------
        // Row edit
        vars_currEditRow  : null,
        vars_onCreating   : false,
        /* Dirty array */
        mx_created   : [],
        mx_updated   : [],
        mx_removed   : [],
    }},
    computed: {
        vars_selLen() {return this.mx_selected.length},
    },
    methods : {
        //-----------------------------------------------
        // Selection
        //-----------------------------------------------
        // [METHOD] Selection : set Select : set selected row
        mx_setSelect(r, multi) {
            let sels = this.mx_selected;
            // 1. check flag
            let _multiFlag = multi!==undefined ? multi : this.mx_options.multiSelect;
            // 2. Do toggle!
            if(_multiFlag) {
                // 2.1 multi mode
                if(r.__selected) { 
                    // 2.1.1 Pop row
                    sels.find((s,i)=>{return (s === r) && sels.splice(i,1);})
                    this.vars_lastSelKey = r;
                    this.mx_setValue(r, '__selected', false)
                } else {
                    // 2.1.2 Push row
                    sels.push(r);
                    this.vars_lastSelKey = r;
                    this.mx_setValue(r, '__selected', true)
                }
            } else {
                var beforeCnt = sels.length, beforeFlag = r.__selected;
                // 2.2 single mode
                this.mx_resetSelect();
                if(beforeFlag && beforeCnt === 1) {
                    // 2.2.1 Deselect
                    this.vars_lastSelKey = r;
                    this.mx_setValue(r, '__selected', false)
                } else {
                    // 2.2.1 Select row
                    this.mx_selected.push(r);
                    this.vars_lastSelKey = r;
                    this.mx_setValue(r, '__selected', true)
                }
            }
            
            this.mx_fireEvent('selected',this.mx_getSelected())
        },
        // [METHOD] Selection : reset Select - reset all
        mx_resetSelect() {
            let sels = this.mx_selected;
            for(var i=0, ii=sels.length; i<ii; i++) {
                let s = sels[i];
                this.mx_setValue(s, '__selected', false)
            }
            this.mx_selected.splice(0);
            this.mx_fireEvent('selected',this.mx_getSelected())
        },
        // [METHOD] Selection : Select all row
        mx_selectAll() {
            var isInternal = this.mx_options.pagination && this.mx_options.internalPaging;
            var st = 0, ed = this.vars_dataSize;
            if(isInternal) {
                st = (this.mx_pager.currentPage-1)*this.mx_pager.rowsPerPage;
                ed = Math.min(st + this.mx_pager.rowsPerPage, this.vars_dataSize, this.items.length);
            }
            this.mx_selected = this.items.slice(st, ed);
            for(var i=st, ii=ed; i<ii ; i++) {
                this.mx_setValue(this.items[i], '__selected', true)
            }
            this.mx_fireEvent('selected',this.mx_getSelected())
        },
        // [METHOD] Selection : Set select - range : set range selected row
        mx_setRangeSelect(r, append) {
            let fr = this.vars_lastSelKey, to = r;
            // 1. get row & idx
            if(!fr || !to) {return;}
            var ifr, ito;
            this.mx_viewData.forEach((r,i) => {
                if(r === fr) ifr = i;
                if(r === to) ito = i;
            })
            let imin = ifr<ito?ifr:ito,
                imax = ifr<ito?ito:ifr;
            // 2. Release selected flag
            if( !append ) {this.mx_resetSelect()}
            // 3. Make new Array
            let apnd = this.mx_viewData.slice(imin, imax+1);
            apnd.forEach(v=>{
                if(apnd.__selected) {return}
                this.mx_setValue(v, '__selected', true)
                this.mx_selected.push(v);
            })
            
            this.mx_fireEvent('selected',this.mx_getSelected())
        },
        // [METHOD] Selection : get Select : return selected row
        mx_getSelected() {
            var sels = this.mx_selected;
            if(this.mx_options.multiSelect) {
                return sels;
            } else {
                return sels.length?sels[0]:undefined;
            }
        },
        
        // [METHOD] Selection : set focus.
        mx_setFocus(r) {
            if(this.mx_options.cellMode) return;
            var beforeFlag = r.__focused;
            // 1. Un-focus previous
            if(this.mx_focused) {
                this.mx_setValue(this.mx_focused, '__focused', false)
                this.mx_focused = null;
            }
            // 2. Do toggle!
            if(!beforeFlag) {
                // 2.2.1 Focus row
                this.mx_setValue(r, '__focused', true)
                this.mx_focused = r;
            }
        },
        // [METHOD] Selection : reset focus.
        mx_resetFocus() {
            this.mx_setFocus();
        },
        //-----------------------------------------------
        // Row Edit
        //-----------------------------------------------
        // [METHOD] Row Edit : Toggle row editable.
        mx_toggleRowModify(row) {
            this.vars_onCreating = false;
            // 1. unSet previous
            if(this.vars_currEditRow && this.vars_currEditRow.__origin) {
                this.mx_setValue(this.vars_currEditRow.__origin, '__editMode', false)
            }
            // 2. set row-self
            this.mx_setValue(row, '__editMode', true)
            // 3. set to global var : currEditRow === clone of row
            var modif = Object.assign({}, row);
            this.mx_setValue(modif, '__origin', row)
            this.vars_currEditRow = modif;
            // x. fire event to page
            this.mx_fireEvent('begin-edit', modif);
            this.mx_fireEvent('btn-modify', modif);
        },
        // [METHOD] Row edit : Validate row.
        mx_checkRowValid(row) {
            var rtn = true;
            this.mx_fieldsInfo.forEach(f => {
                if(f.readonly) {return}
                if(row.__dirty === CONST.VAL.DIRTY.FLAG.UPDATE && !f.edit) {return}
                if(!f.__rules) {return}
                var v = row[f.value];
                rtn = !f.__rules.find(rule => {
                    var txt = rule(v,row,this.mx_caller);
                    if(txt === true) return false;
                    rtn = false;
                    this.mx_addCellMsg(txt, row, f);
                    return true;
                }) && rtn;
                if(rtn) {this.mx_delCellMsg(row, f)}
            });
            return rtn;
        },
        // [METHOD] Row Edit : Save that row. (Editing is over)
        mx_toggleRowSaved(row) {
            // 0. check something.
            // 0.1 not changing
            if(!row) return;
            // 0.2 validation
            if(!this.mx_options.manualValid && !this.mx_checkRowValid(row)) {
                return;
            }
            var origin = row.__origin
            // 1. copy to origin
            this.mx_fieldsInfo.forEach(f => {
                if(!f.edit) {return}
                if(f.saveConverter) {
                    var _v = row[f.value];
                    origin[f.value] = f.saveConverter(_v, row, f);
                } else {
                    origin[f.value] = row[f.value]
                }
            });
            // 2. reset edited
            this.mx_setValue(origin, '__editMode', false)
            // 3. Set dirty & append to changed array
            if(!origin.__dirty) {/*UPDATE-CHANGED*/
                this.mx_updated.push(origin);
                this.mx_setValue(origin, '__dirty', CONST.VAL.DIRTY.FLAG.UPDATE)
            }
            this.vars_currEditRow = null;
            // x. build data
            this.mx_buildData();
            // x. fire event to page
            this.mx_fireEvent('btn-save', row);
            this.mx_fireEvent('data-changed',this.mx_getChanged());
        },
        // [METHOD] Row Edit : I don't want to edit anymore.
        mx_toggleEditCancel() {
            if(!this.vars_currEditRow) return;
            var row = this.vars_currEditRow;
            // 1. reset data
            if(this.vars_onCreating) {
                // 1.1 If on creating?
                this.mx_delCellMsg(row)
                this.mx_viewData.shift();
            } else {
                // 1.2 or Just on edit row
                var origin = row.__origin
                if(origin) {
                    origin.__editMode = false;
                    this.mx_delCellMsg(origin)
                }
            }
            // 2. reseting.
            this.vars_currEditRow = null;
            // x. fire event.
            this.mx_fireEvent('btn-cancel');
        },
        // [METHOD] Row Edit : Destroy it.
        mx_removeRows(rows) {
            const selCnt = this.getSelected().length;
            // 1. check argument
            if( !rows || !rows.length ) return;
            // 2. remove prev-message
            rows.forEach(r => this.mx_delCellMsg(r));
            // 2. append to removes array
            rows.forEach(row => {/*UPDATE-CHANGED*/
                if(row.__dirty===CONST.VAL.DIRTY.FLAG.CREATE) {
                    // 2.1 pop from created array
                    this.mx_created.find((cRow, idx) => {
                        if(row.__id !== cRow.__id) {return false}
                        this.mx_created.splice(idx, 1);
                        return true
                    });
                } else if(row.__dirty===CONST.VAL.DIRTY.FLAG.UPDATE) {
                    // 2.2 pop from updated array & push to removed
                    // 2.2.1 pop updated
                    this.mx_updated.find((cRow, idx) => {
                        if(row.__id !== cRow.__id) { return false;}
                        this.mx_updated.splice(idx, 1);
                        return true
                    });
                    // 2.2.2 push removed
                    this.mx_setValue(row, '__dirty', CONST.VAL.DIRTY.FLAG.REMOVE)
                    this.mx_removed.push(row);
                } else { // EMPTY or CONST.VAL.DIRTY.FLAG.UPDATE
                    // 2.3 append to removed array
                    this.mx_setValue(row, '__dirty', CONST.VAL.DIRTY.FLAG.REMOVE)
                    this.mx_removed.push(row);
                }
            })
            // 3. remove to items(origin data)
            // 3.1 make id set(rows)
            var set = new Set(rows.map(r=>r.__id));
            // 3.2 loop orign data
            var nArr = this.items.filter(r =>!set.has(r.__id));
            // 3.2.0 [deprecated] 전체다 복사하는거 보다, 아래가 조금 더 빠름.
            //       코딱지 반만큼
            //this.items.splice(0,this.items.length, nArr);
            this.items.splice(0);
            nArr.forEach(r=>this.items.push(r));
            // x. fire event
            this.mx_fireEvent('btn-delete', rows, selCnt)
            this.mx_fireEvent('data-changed',this.mx_getChanged());
            // x. do something after remove Rows.
            // TODO set select First? or Next item?
            this.mx_resetSelect();
        },
        // [METHOD] Row edit : Create empty(new) row & save
        mx_createEmptyRow() {
            // 0. Prepare
            var nRow = Object.assign({},this.mx_setHeaders_makeDefaultObj());
            nRow.__dirty = CONST.VAL.DIRTY.FLAG.CREATE;
            // 1. append field
            this.mx_fieldsInfo.forEach(f => {
                nRow[f.value] = nRow[f.value] || undefined;
            })
            // 2. additional fields..
            this.mx_initItem(nRow, null);
            this.items.unshift(nRow);
            // 3. Set flag & other proc.
            this.mx_setValue(nRow, '__dirty', CONST.VAL.DIRTY.FLAG.CREATE)
            this.mx_created.push(nRow);
            // 4. Set focus if cellEdit
            if(this.mx_options.cellEdit) {
                const IDX = 0; // unshift..
                this.mx_focusFirstCell(IDX);
            }
            // x. fire event(send data before reset)
            this.mx_fireEvent('btn-add');
            this.mx_fireEvent('data-changed',this.mx_getChanged());
        },
        // [METHOD] Row Edit : Prepare create. append empty row first.
        mx_addEmptyRow() {
            var nRow = Object.assign({},this.mx_setHeaders_makeDefaultObj());
            nRow.__dirty = CONST.VAL.DIRTY.FLAG.CREATE;
            // 1. append field
            this.mx_fieldsInfo.forEach(f => {
                nRow[f.value] = nRow[f.value] || undefined;
            })
            // 2. additional fields..
            this.mx_initItem(nRow, null); // 임시 idx -1
            //nRow.__selected = true; // 가라로 하지 말고 진짜 선택해야 하나?
            nRow.__editMode = true;
            // 3. append first
            this.mx_viewData.unshift(nRow);
            // 4. make cloned row
            this.$set(this, 'vars_currEditRow', nRow)
            //this.vars_currEditRow = nRow; // need copy?
            this.vars_onCreating = true;
            // 5. Scroll to Top
            this.mx_eventBus.$emit('set-scroll-top',0)
            // x. remove all message
            this.mx_delCellMsg();
            // x. fire event.
            this.mx_fireEvent('btn-add');
        },
        // [METHOD] Row Edit : Prepare create. append empty row first.
        mx_createNewRow(row) {
            if(!row) return;
            var _nRow = row;
            // 0.2 validation
            if(!this.mx_options.manualValid && !this.mx_checkRowValid(_nRow)){
                return;
            }
            // 0.3 Convert value
            this.mx_fieldsInfo.forEach(f => {
                if(!f.readonly) {return}
                if(f.saveConverter) {
                    _nRow[f.value] = f.saveConverter(_nRow[f.value], _nRow, f);
                }
            });
            // 1. append to first
            this.mx_initItem(_nRow);
            this.items.unshift(_nRow);
            // 2. re-ordering -> watch.items
            // 3. reset flags
            this.mx_setValue(_nRow, '__editMode', false)
            this.mx_setValue(_nRow, '__selected', false)
            // 4. Set dirty & append to changed array
            this.mx_setValue(_nRow, '__dirty', CONST.VAL.DIRTY.FLAG.CREATE)
            this.mx_created.push(_nRow);
            // 5. reset global edit-var
            this.vars_currEditRow = null;
            // x. build data
            //this.mx_buildData();
            // x. fire event
            this.mx_fireEvent('btn-save',_nRow);
            this.mx_fireEvent('data-changed',this.mx_getChanged());
        },
        // [METHOD] Row Edit : Get dirty array
        mx_getChanged() {
            return {
                created:this.mx_created,
                updated:this.mx_updated,
                removed:this.mx_removed
            };
        },
        // [METHOD] Row Edit : is Changed or not.
        mx_isChanged() {
            var res = 0;
            res += this.mx_created?this.mx_created.length:0;
            res += this.mx_updated?this.mx_updated.length:0;
            res += this.mx_removed?this.mx_removed.length:0;
            return res;
        },
        // [METHOD] Row Edit : Validate all changed data.
        mx_validChanged() {
            var res = true;
            if(this.mx_created) {
                this.mx_created.forEach((r)=>{
                    var flag = this.mx_checkRowValid(r);
                    res = res && flag; 
                })
            }
            if(this.mx_updated) {
                this.mx_updated.forEach((r)=>{
                    var flag = this.mx_checkRowValid(r)
                    res = res && flag;
                })
            }
            // [IOPS] valid onCreating row
            if(!!this.vars_currEditRow) {
                const editRow = this.vars_currEditRow;
                var flag = this.mx_checkRowValid(editRow)
                res = res && flag;
            }
            return res;
        },
    }
}